import React, { Component } from "react";
import Autocomplete from "react-autocomplete";
import API from "../../apiService.js";
import moment from "moment";
import ALERT from "../component/Alert";
import { Formik, Form } from "formik";
import * as Yup from "yup";
const SignupSchema = Yup.object().shape({
    icd: Yup.string().required("ICD HARUS DIISI"),
});
export class AssesmentGizi extends Component {
    constructor(props) {
        super(props);
        // console.log(props.patient.id)
        this.state = {
            date: moment(new Date()).format("YYYY-MM-DD"),
            dataIcd: [],
            icd_rujukan: [],
            icd: [
                {
                    visit_id: "",
                    visit_inpatient_detail_id: "",
                    icd_code: "",
                    icd_name: "",
                    explanation: "",
                    case: "new",
                    log: false,
                },
            ],
            value: "",
            icdSelected: "",
            data:
                props.patient.examinations.length > 0
                    ? props.patient.examinations[0]
                    : [],
        };
        this.timeout = 0;
        // Bind `this` context to functions of the class
        this.onChangeIcd = this.onChangeIcd.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.getItemValue = this.getItemValue.bind(this);
        this.renderItem = this.renderItem.bind(this);
        this.retrieveDataAsynchronouslyIcd =
            this.retrieveDataAsynchronouslyIcd.bind(this);
    }

    componentDidMount() {
        if (this.props.patient.gizi_diagnoses[0]) {
            this.setState({
                icd: this.props.patient.gizi_diagnoses,
            });
        }
        if (this.props.patient.diagnoses[0]) {
            this.setState({
                icd_rujukan: this.props.patient.diagnoses,
            });
        }

        this.icd.focus();
    }

    handleInputNameChangeIcd = (idx) => (evt) => {
        const val = evt.split("_", 3);
        const newIcd = this.state.icd.map((icd, sidx) => {
            if (idx !== sidx) return icd;
            return {
                ...icd,
                visit_id: this.props.patient.id,
                icd_code: val[0],
                icd_name: val[1],
                explanation: "",
                case: "new",
                log: false,
            };
        });

        this.setState({ icd: newIcd });
        setTimeout(
            function () {
                let parent = [];
                parent = { data: this.state.icd, param: "diagnoses" };
                this.props.parentCallback(parent);
            }.bind(this),
            200
        );
    };

    handleSubmit = (evt) => {
        this.postIcd();
    };

    postIcd = async (e) => {
        var param = this.state.data;
        const anam = await API.put("registration/examination/update", param);
        const diagnose = this.state.icd;
        const res = await API.post("/management/gizi_diagnoses/create", { diagnose });
        if (res.code === 200) {
            ALERT("success", "Berhasil Menyimpan Data ");
        } else {
            ALERT("error", "gagal menyimpan data");
        }
    };

    handleAddInput = (x) => (evt) => {
        this.setState({
            [evt.target.name]: x,
        });
    };

    handleRemoveInputIcd = (idx) => (evt) => {
        // const val = evt.target.value;
        const icd = [...this.state.icd];
        icd[idx].log = true;
        if (icd[idx].icd_code !== "") {
            this.setState({ icd });
        } else {
            this.setState({
                [evt.target.name]: this.state.icd.filter((s, sidx) => idx !== sidx),
            });
        }
    };

    retrieveDataAsynchronouslyIcd = async (e) => {
        const res = await API.get("management/gizi_diagnoses/ref?keyword=" + e);
        if (res.code === 200) {
            this.setState({
                dataIcd: res.data.data,
            });
        } else {
            console.error("Cannot load data from remote source");
        }
    };

    onChangeIcd = (idx) => (evt) => {
        const newIcd = this.state.icd.map((icd, sidx) => {
            if (idx !== sidx) return icd;
            return {
                ...icd,
                visit_id: this.props.patient.id,
                icd_code: "",
                icd_name: evt.target.value,
                explanation: "",
                case: "new",
                log: false,
            };
        });

        this.setState({ icd: newIcd });

        /**
         * Handle the remote request with the current text !
         */
        const par = evt.target.value;
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            if (par.length > 2) {
                this.retrieveDataAsynchronouslyIcd(par);
            }
        }, 500);
        // if (evt.target.value.length > 2) {
        // setTimeout(event => {
        // this.retrieveDataAsynchronouslyIcd(par);
        // }, 300);
        // console.log("The Input Text has changed to ", par);
        // }
    };

    /**
     * Callback triggered when the autocomplete input changes.
     *
     * @param {Object} val Value returned by the getItemValue function.
     * @return {Nothing} No value is returned
     */
    onSelect(val) {
        this.setState({
            value: val,
        });
        const x = val.split("_", 2);
        console.log("Option from 'database' selected : ", x);
    }

    /**
     * Define the markup of every rendered item of the autocomplete.
     *
     * @param {Object} item Single object from the data that can be shown inside the autocomplete
     * @param {Boolean} isHighlighted declares wheter the item has been highlighted or not.
     * @return {Markup} Component
     */
    renderItem(item, isHighlighted) {
        return (
            <div
                key={item.id}
                style={{ background: isHighlighted ? "lightgray" : "white" }}
            >
                {item.code} _ {item.name} _ [{item.name_en}]
            </div>
        );
    }

    getItemValue(item) {
        // You can obviously only return the Label or the component you need to show
        // In this case we are going to show the value and the label that shows in the input
        // something like "1 - Microsoft"
        return `${item.code}_${item.name}_${item.non_specialist}`;
    }

    onReload = () => {
        this.props.history.push("/pelayanan");
    };
    chageIcdCase = (idx) => (event) => {
        const target = event.target;
        const icd = [...this.state.icd];
        const value = target.type === "checkbox" ? target.checked : target.value;
        if (value) {
            icd[idx].case = "new";
        } else {
            icd[idx].case = "old";
        }
        this.setState({ icd });
    };
    chageIcdKeterangan = (idx) => (event) => {
        const target = event.target;
        const icd = [...this.state.icd];
        const value = target.value;
        icd[idx].explanation = value;
        this.setState({ icd });
    };

    // examination
    handleChangeText = (event) => {
        const value = event.target.value;
        const object = event.target.name;
        let data;
        this.setState(
            (prevState) => ({
                data: {
                    // object that we want to update
                    ...prevState.data, // keep all other key-value pairs
                    [object]: value, // update the value of specific key
                },
            }),
            () => {
                data = { data: [this.state.data], param: "examinations" };
                this.props.parentCallback(data);
            }
        );
    };

    render() {
        let DeletedIcd = [];
        this.state.icd.map((icd, idx) => {
            if (icd.log) {
                DeletedIcd[idx] = icd;
            }
        });
        const deletedIcdInformation = DeletedIcd.map((data, key) => {
            return (
                <a key={key} className="dropdown-item">
                    {data.icd_code} - {data.icd_name}
                </a>
            );
        });
        console.log(this.state.icd);

        return (
            <>
                <Formik
                    enableReinitialize
                    initialValues={{
                        icd: this.state.icd[0].icd_code,
                    }}
                    validationSchema={SignupSchema}
                    onSubmit={(values) => {
                        this.handleSubmit();
                        this.props.nextTab();
                    }}
                >
                    {({ values, errors, touched }) => (
                        <Form>
                            <div className="form-group row">
                                <div className="col-md-5 ">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-form-label col-form-label-sm"
                                    >
                                        Diagnosis Rujukan
                                    </label>
                                </div>
                                <div className="col-md-7 ">
                                    {this.state.icd_rujukan.map(v => (
                                        <div>{v.icd_code} - {v.icd_name}</div>
                                    ))}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md-5 ">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label
                                                htmlFor="example-text-input"
                                                className="col-form-label col-form-label-sm"
                                            >
                                                Diagnosis
                                            </label>
                                        </div>
                                        {DeletedIcd.length > 0 ? (
                                            <div>
                                                <div className="col-auto">
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-danger mr-0"
                                                        data-toggle="dropdown"
                                                        aria-haspopup="true"
                                                        aria-expanded="false"
                                                    >
                                                        dihapus
                                                    </button>
                                                    <div className="dropdown-menu dropdown-menu-left">
                                                        {deletedIcdInformation}
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div></div>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-7">
                                    {this.state.icd.map((icd, idx) => {
                                        if (icd.log === false || icd.log === 0)
                                            return (
                                                <div key={idx} className="form-group row">
                                                    <Autocomplete
                                                        inputProps={{
                                                            className: "form-control form-control-sm",
                                                            placeholder: "ketikkan minimal 3 huruf diagnosa",
                                                        }}
                                                        ref={(input) => {
                                                            this.icd = input;
                                                        }}
                                                        getItemValue={this.getItemValue}
                                                        items={this.state.dataIcd}
                                                        renderItem={this.renderItem}
                                                        value={
                                                            this.state.icd[idx].icd_name
                                                                ? this.state.icd[idx].icd_code +
                                                                "" +
                                                                this.state.icd[idx].icd_name
                                                                : ""
                                                        }
                                                        onChange={this.onChangeIcd(idx)}
                                                        onSelect={this.handleInputNameChangeIcd(idx)}
                                                        menuStyle={{
                                                            borderRadius: "3px",
                                                            boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                                                            background: "rgba(255, 255, 255, 0.9)",
                                                            padding: "2px 0",
                                                            fontSize: "90%",
                                                            // position: "absolute",
                                                            overflow: "auto",
                                                            zIndex: "100",
                                                            maxHeight: "110%", // TODO: don't cheat, let it flow to the bottom
                                                        }}
                                                        wrapperStyle={{
                                                            maxWidth: "81.66667%",
                                                            flex: "0 0 81.66667%",
                                                            overflow: "auto",
                                                            maxHeight: '300px'
                                                        }}
                                                    />
                                                    <label className="custom-toggle custom-toggle-success">
                                                        <input
                                                            type="checkbox"
                                                            checked={
                                                                this.state.icd[idx].case === "new"
                                                                    ? "checked"
                                                                    : ""
                                                            }
                                                            onChange={this.chageIcdCase(idx)}
                                                        />
                                                        <span
                                                            className="custom-toggle-slider rounded-circle"
                                                            data-label-off="lama"
                                                            data-label-on="baru"
                                                        />
                                                    </label>
                                                    <div>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-danger"
                                                            style={{ maxWidth: "10%" }}
                                                            name="icd"
                                                            onClick={this.handleRemoveInputIcd(idx)}
                                                        >
                                                            -
                                                        </button>
                                                    </div>
                                                    <div className="row col-md-12 mt-2">
                                                        <div className="col-md-3">
                                                            <label className="form-control-label">
                                                                Keterangan
                                                            </label>
                                                        </div>
                                                        <div className="col-md-9">
                                                            <textarea
                                                                className="form-control form-control-sm"
                                                                onChange={this.chageIcdKeterangan(idx)}
                                                                value={this.state.icd[idx].explanation}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                    })}
                                    <button
                                        type="button"
                                        name="icd"
                                        style={{ marginLeft: "2%" }}
                                        onClick={this.handleAddInput(
                                            this.state.icd.concat([
                                                {
                                                    visit_id: "",
                                                    icd_code: "",
                                                    icd_name: "",
                                                    explanation: "",
                                                    case: "new",
                                                    log: false,
                                                },
                                            ])
                                        )}
                                        className="btn btn-sm btn-primary"
                                    >
                                        Add
                                    </button>
                                    {errors.icd && touched.icd ? (
                                        <div style={{ color: "red" }}>{errors.icd}</div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="form-group row">
                                <label
                                    htmlFor="example-text-input"
                                    className="col-md-5 col-form-label col-form-label-sm"
                                >
                                    Diagnosa Naratif
                                </label>
                                <div className="col-md-7">
                                    <div className="row">
                                        <textarea
                                            className="form-control form-control-sm"
                                            type="text"
                                            placeholder="Diagnosa naratif"
                                            name="diagnostic_narativ"
                                            onChange={this.handleChangeText}
                                            value={this.state.data?.diagnostic_narativ}
                                        />
                                    </div>
                                </div>
                            </div>
                            <button className="btn btn-primary">Simpan</button>
                            <button className="btn btn-danger" onClick={this.onReload}>
                                Tutup
                            </button>
                        </Form>
                    )}
                </Formik>
            </>
        );
    }
}

export default AssesmentGizi
